<template>
  <Adminlte>
      <div class="box box-primary center-block">
        <div class="box-header with-border">
          <i class="fa fa-envelope-o font-dark"></i>
          <h3 class="box-title">Envio de e-mails</h3>
        </div>

        <section class="content">
          <div class="row main-row">
            <div class="col-xs-12 col-md-4">
              <div class="inner-box">
                <h4>
                  Destinatários &nbsp;
                  <button @click="selectAllParks()" type="button" class="btn btn-default btn-xs">Selecionar todos</button>
                  <button @click="clearSelectedParks()" type="button" class="btn btn-default btn-xs">Limpar</button>
                </h4>

                <div class="scrollable-content">
                  <div v-for="park in parks" :key="park.id" class="checkbox">
                    <label>
                      <input v-model="park.isSelected" type="checkbox"> {{ park.name }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-8">
              <form role="form">
                <div class="inner-box">
                  <p v-if="errors.recipients" class="text-red">
                    <i class="fa fa-exclamation-circle">&nbsp;</i>
                    {{ errors.recipients }}
                  </p>

                  <div class="form-group">
                    <label for="subject">Assunto</label>
                    <input type="text" class="form-control" id="subject" placeholder="Entre com o assunto" v-model="subject">
                    <p v-if="errors.subject" class="text-red">
                      <i class="fa fa-exclamation-circle">&nbsp;</i>
                      {{ errors.subject }}
                    </p>
                  </div>

                  <div class="form-group">
                    <label>Corpo do e-mail</label>
                    <vue-html5-editor :content="body" @change="updateContent" :height="300"></vue-html5-editor>
                    <p v-if="errors.body" class="text-red">
                      <i class="fa fa-exclamation-circle">&nbsp;</i>
                      {{ errors.body }}
                    </p>
                  </div>

                  <div class="text-right">
                    <button type="submit" class="btn btn-sm btn-default" :disabled="isSending" v-on:click.prevent="onSend">
                      <i class="fa fa-send-o"></i>&nbsp; Enviar
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
  </Adminlte>
</template>

<script>
  import Adminlte from '@/components/template/Adminlte'
  import { BackendApi } from '@/services/backend_api'

  export default {
    name: 'MailingHome',
    components: { Adminlte },
    data: function () {
      return {
        parks: [],
        subject: '',
        body: '',
        errors: {
          recipients: '',
          subject: '',
          body: ''
        },
        isSending: false
      }
    },
    async mounted () {
      this.parks = await this.getParks()
    },
    methods: {
      async getParks () {
        const response = await BackendApi.getAnonymousClient().get('/parks?hideLogo=true&orderBy=name&limit=0')
        const parksResponseWithNoLinksNeitherTotalElements = Object.values(response.data).slice(0, -2)
        return parksResponseWithNoLinksNeitherTotalElements.map((park) =>
          Object.assign({ isSelected: false }, park)
        )
      },
      selectAllParks () {
        this.parks.forEach((park) => {
          park.isSelected = true
        })
      },
      clearSelectedParks () {
        this.parks.forEach((park) => {
          park.isSelected = false
        })
      },
      updateContent (data) {
        this.body = data
      },
      onSend () {
        if (this.validateAndGetErrors()) {
          this.sendMails()
        }
      },
      sendMails () {
        this.isSending = true

        BackendApi.getClient().post('/mailing', {
          recipients: this.recipients,
          subject: this.subject,
          body: this.body
        }).then(() => {
          this.subject = ''
          this.body = ''
          this.clearSelectedParks()

          this.isSending = false

          this.$notify({
            type: 'success',
            title: 'E-mails enviados',
            text: 'A mensagem foi enviada por e-mail para os destinatários selecionados.'
          })
        }).catch(() => {
          this.isSending = false

          this.$notify({
            type: 'error',
            title: 'Erro ao enviar e-mails',
            text: 'Ocorreu algum erro ao enviar a mensagem para os destinatários selecionados.'
          })
        })
      },
      validateAndGetErrors () {
        this.validate()
        return this.isValid()
      },
      validate () {
        this.errors.recipients = !this.recipients.length ? 'Selecione ao menos um destinatário na caixa ao lado' : ''
        this.errors.subject = this.validateSubject()
        this.errors.body = this.validateBody()
      },
      validateSubject () {
        if (!this.subject) {
          return 'Por favor, preencha um assunto para o e-mail a ser enviado'
        }
        if (this.subject.length < 5) {
          return 'O assunto do e-mail deve ter pelo menos 5 caracteres'
        }
        if (this.subject.length > 80) {
          return 'O assunto do e-mail deve ter no máximo 80 caracteres'
        }
        return ''
      },
      validateBody () {
        if (!this.body) {
          return 'Por favor, preencha o corpo do e-mail'
        }
        if (this.body.length < 5) {
          return 'O corpo do e-mail deve ter pelo menos 5 caracteres'
        }
        if (this.body.length > 5242880) {
          return 'O corpo do e-mail ultrapassou o limite máximo de caracteres permitido'
        }
        return ''
      },
      isValid () {
        return !this.errors.recipients && !this.errors.subject && !this.errors.body
      }
    },
    computed: {
      recipients: function () {
        return this.parks.filter((park) => park.isSelected).map((park) => park.email)
      }
    }
  }
</script>

<style scoped>
  .inner-box {
    background-color: #488ab3;
    box-shadow: 0px 1px 5px #888888;
    padding: 10px;
    margin-bottom: 15px;
    color: white;
  }

  .scrollable-content {
    max-height: 477px;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// MailingHome.vue?fb751abc